import { Quote, Star, ExternalLink } from "lucide-react";
import { GOOGLE_PROFILE_URL } from "./data";

export const Reviews = () => (
    <section id="reviews" className="bg-white py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto text-center mb-14">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-teal-600 mb-4">Patient Reviews</p>
                <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    What Our Patients Say
                </h2>
                <p className="mt-4 text-base leading-relaxed text-slate-600">
                    Verified patient feedback will appear here soon.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-testid="reviews-grid">
                {[1, 2, 3].map((n) => (
                    <article
                        key={n}
                        data-testid={`review-card-${n}`}
                        className="bg-slate-50 rounded-2xl p-7 border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex flex-col"
                    >
                        <Quote className="h-7 w-7 text-teal-200 mb-4" strokeWidth={1.5} />
                        <p className="text-sm leading-relaxed text-slate-500 italic flex-1">
                            "Add verified patient review here."
                        </p>
                        <div className="mt-6 pt-5 border-t border-slate-200/70 flex items-center justify-between">
                            <div>
                                <p className="text-sm font-semibold text-slate-700">[Patient Name]</p>
                                <p className="text-xs text-slate-400">Google Review</p>
                            </div>
                            <div className="flex gap-0.5" aria-label="Rating placeholder">
                                {[...Array(5)].map((_, i) => (
                                    <Star key={i} className="h-3.5 w-3.5 text-slate-300" strokeWidth={1.5} />
                                ))}
                            </div>
                        </div>
                    </article>
                ))}
            </div>

            <div className="mt-12 text-center">
                <a
                    href={GOOGLE_PROFILE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="view-google-reviews-btn"
                    className="inline-flex items-center gap-2 rounded-full border border-teal-600 bg-white px-7 py-3.5 text-sm font-semibold text-teal-700 transition-all duration-200 hover:bg-teal-600 hover:text-white hover:-translate-y-0.5"
                >
                    <ExternalLink className="h-4 w-4" />
                    View Google Reviews
                </a>
            </div>
        </div>
    </section>
);
